import { makeStyles } from "tss-react/mui"
import { useNavigate } from "react-router-dom"
import { Box, Grid, Typography } from "@mui/material"
import { faCheck } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LanguageSelector } from "../../shared/components/languageSelector/LanguageSelector"
import BackgroundImage from "./assets/large-GoPay-manager-Frontpage-background.jpg"
import { StandardButton } from "../../shared/components/buttons/StandardButton"
import { LocalizedStrict } from "../localization/components/AppLocalized"
import FrontpageLogo from "!file-loader!./assets/facilitynet-logo-white-no-bg.svg"
import { USER_NAME_ROUTE } from "../../constants/routes"
import { useEffect } from "react"

const useStyles = makeStyles()((theme) => ({
    page: {
        height: "100vh",
        backgroundImage: `url(${BackgroundImage})`,
        backgroundRepeat: "no-repeat",
        backgroundColor: theme.palette.mode === "light" ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: "cover",
        backgroundPosition: "bottom",
        backgroundPositionY: "70%",

        [theme.breakpoints.up("sm")]: {
            // Adjust background image position on mobile landscape
            backgroundPositionX: "50%",
        },

        [theme.breakpoints.down(600)]: {
            // Adjust background image position on mobile landscape
            backgroundPositionX: "60%",
        },
    },
    loginButton: {
        marginLeft: "1.5rem",
        borderColor: theme.palette.common.white,
    },
    frontPageLogo: {
        width: "10rem",
        height: "auto",
        objectFit: "contain",

        [theme.breakpoints.down(650)]: {
            width: "6rem",
        },
    },
    title: {
        marginLeft: "5rem",
        fontSize: "3.5rem",
        lineHeight: "3.5rem",
        width: "30rem",

        [theme.breakpoints.down(1200)]: {
            fontSize: "3rem",
        },
        [theme.breakpoints.down(860)]: {
            fontSize: "2.5rem",
        },
        [theme.breakpoints.down(820)]: {
            fontSize: "2rem",
            lineHeight: "2.2rem",
            width: "12rem",
        },

        [theme.breakpoints.down(650)]: {
            display: "none",
        },
    },
    subTitleTest: {
        fontSize: "1.5rem",

        [theme.breakpoints.down(1200)]: {
            fontSize: "1.5rem",
            width: "25rem",
        },
        [theme.breakpoints.down(1062)]: {
            width: "17rem",
        },
        [theme.breakpoints.down(860)]: {
            fontSize: "1.4rem",
        },
        [theme.breakpoints.down(820)]: {
            fontSize: "1.2rem",
            width: "10rem",
        },
    },
    subTitleContainer: {
        marginTop: "1rem",
        marginLeft: "5.5rem",
        width: "30rem",
        display: "flex",
        alignItems: "flex-start",
        flexWrap: "nowrap",
        [theme.breakpoints.down(650)]: {
            fontSize: "1rem",
            display: "none",
        },
    },
    topBar: {
        padding: "1.5rem",
    },
    content: {
        marginTop: "7rem",
        [theme.breakpoints.down(1025)]: {},
    },
}))

type StartPageLayoutProps = Readonly<{}>

export function StartPageLayout({}: StartPageLayoutProps) {
    const { classes } = useStyles()
    const navigate = useNavigate()

    useEffect(() => navigate(USER_NAME_ROUTE), [])

    return null

    return (
        <Grid
            container
            direction="column"
            component="main"
            className={classes.page}
            alignItems="flex-start"
            wrap="nowrap"
        >
            <Grid item container justifyContent="space-between" wrap="nowrap" className={classes.topBar}>
                <img src={FrontpageLogo} className={classes.frontPageLogo} />

                <Grid item display="flex">
                    <LanguageSelector />
                    <LocalizedStrict id="start-page-layout-login-button-label">
                        <StandardButton
                            variant="outlined"
                            fullWidth={false}
                            color="white"
                            className={classes.loginButton}
                            onClick={() => navigate(USER_NAME_ROUTE)}
                            disableRipple
                            disableFocusRipple
                        >
                            Login
                        </StandardButton>
                    </LocalizedStrict>
                </Grid>
            </Grid>

            <Grid container className={classes.content}>
                <Grid item>
                    <LocalizedStrict id="start-page-layout-title">
                        <Typography color={"#fff"} variant="h6" className={classes.title}>
                            Easy Canteen Management
                        </Typography>
                    </LocalizedStrict>
                    <Box className={classes.subTitleContainer}>
                        <FontAwesomeIcon icon={faCheck} size="2x" style={{ color: "#fff", paddingRight: "1rem" }} />
                        <LocalizedStrict id="start-page-layout-sub-title-1">
                            <Typography color={"#fff"} variant="h3" className={classes.subTitleTest}>
                                Accept payments with the POS and mobile phone
                            </Typography>
                        </LocalizedStrict>
                    </Box>

                    <Box className={classes.subTitleContainer}>
                        <FontAwesomeIcon icon={faCheck} size="2x" style={{ color: "#fff", paddingRight: "1rem" }} />
                        <LocalizedStrict id="start-page-layout-sub-title-2">
                            <Typography color={"#fff"} variant="h3" className={classes.subTitleTest}>
                                Get insight into sales figures with Facilitynet Manager
                            </Typography>
                        </LocalizedStrict>
                    </Box>

                    <Box className={classes.subTitleContainer}>
                        <FontAwesomeIcon icon={faCheck} size="2x" style={{ color: "#fff", paddingRight: "1rem" }} />
                        <LocalizedStrict id="start-page-layout-sub-title-3">
                            <Typography color={"#fff"} variant="h3" className={classes.subTitleTest}>
                                Better communication between merchant and customers
                            </Typography>
                        </LocalizedStrict>
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    )
}
